<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
        lg12>
        <material-card
          color="general"
          class="card-tabs"
          title="Sales PO"
          text="List of Purchase Order(s)"
        >
          <sales-po/>
<!--          <v-flex-->
<!--            slot="header"-->
<!--          >-->
<!--            <v-tabs-->
<!--              v-model="tab"-->
<!--              color="transparent"-->
<!--              slider-color="black"-->
<!--            >-->

<!--              <v-tab-->
<!--                v-for="item in tabSlot"-->
<!--                :key="item.key"-->
<!--              >-->
<!--                {{ item.tab }}-->
<!--              </v-tab>-->
<!--            </v-tabs>-->
<!--          </v-flex>-->

<!--          <v-tabs-items v-model="tab" :touchless="true">-->
<!--            <v-tab-item-->
<!--              key="1"-->
<!--            >-->
<!--              <sales-po/>-->
<!--            </v-tab-item>-->
<!--            <v-tab-item-->
<!--              key="2"-->
<!--            >-->
<!--              <assign-visit visit-type="SALES"/>-->
<!--            </v-tab-item>-->
<!--            <v-tab-item-->
<!--              key="3"-->
<!--            >-->
<!--              <assign-visit visit-type="PROJECT"/>-->
<!--            </v-tab-item>-->
<!--          </v-tabs-items>-->
        </material-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
  import SalesPo from './salesadm/SalesPo'
  import AssignVisit from './visit/AssignVisit'

  export default {
    name: 'SalesAdm',
    components: { SalesPo, AssignVisit },
    data: () => ({
      tab: null,
      tabSlot: [
        { key: 1, tab: 'PO Creation', content: 'Tab 1 Content' },
        { key: 2, tab: 'Assign Sales Visit', content: 'Tab 2 Content' },
        { key: 3, tab: 'Assign Project Visit', content: 'Tab 2 Content' }
      ]
    }),

    computed: {},
    watch: {},
    created () {
    },
    methods: {}

  }
</script>
<style>

</style>
